import React, { Component, PropTypes } from 'react';
import SearchBox from 'help/containers/search_box';
import ArticleLink from 'help/components/article_link';
import { v4 } from 'node-uuid';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

export default class SearchResults extends Component {
  componentDidMount() {
    this.props.search();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.params.searchStr !== this.props.params.searchStr) {
      newProps.search();
    }
  }

  render() {
    const { isLoading, data, params } = this.props;

    if (isLoading || !data) {
      return (
        <section className="block block-help-search">
        <Meta
          title="Help"
          meta={[
            { name: "robots", content: "noindex,follow" },
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/search/${params.searchStr}`) }]} />
          <div className="row align-center">
            <div className="columns medium-12 large-8">
              <SearchBox placeholder="How can we help?" />
            </div>
          </div>
        </section>
      );
    }

    const clientResults = data.results.filter(a => a.category.user_type === "client");
    const creativeResults = data.results.filter(a => a.category.user_type === "creative");

    return (
      <div className="search-page">
        <Meta
          title="Help"
          meta={[
            { name: "robots", content: "noindex,follow" },
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/search/${params.searchStr}`) }]} />
        <section className="block block-help-search">
          <div className="row align-center">
            <div className="columns medium-12 large-8">
              <SearchBox placeholder="How can we help?" />
            </div>
          </div>
        </section>
        <section className="block block-help-search-results">
          <div className="row align-center">
            <div className="medium-12 large-8 columns">
              { data.results.length > 0 &&
              <h2>You searched for &quot;{ params.searchStr }&quot;&hellip;</h2> }

              { clientResults.length > 0 &&
              <div className="block">
                <h2>Clients</h2>
                <ul className="article-list search-results">
                  { clientResults.map(article => (
                    <li key={v4()}>
                      <ArticleLink
                        {...article}
                        categorySlug={article.category.slug}
                      />
                    </li>
                  )) }
                </ul>
              </div> }

              { creativeResults.length > 0 &&
              <div className="block">
                <h2>Creatives</h2>
                <ul className="article-list search-results">
                  { creativeResults.map(article => (
                    <li key={v4()}>
                      <ArticleLink
                        {...article}
                        categorySlug={article.category.slug}
                      />
                    </li>
                  )) }
                </ul>
              </div> }

              { !data.results.length && <div className="no-results">
                <h2>No articles found, please try using different terms.</h2>
              </div> }
            </div>
          </div>
        </section>
      </div>
    );
  }
}

SearchResults.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.any,
  search: PropTypes.func.isRequired,
  params: PropTypes.shape({
    searchStr: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./help/components/search_results.jsx